import React from 'react';

const ViewForm = (props) => {
  return (
    <>
      <div className="modal fade" id="viewForm">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title text-align-center">
                View Applicant Form
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">x</span>
                </button>
              </h5>
            </div>
            <div className="modal-body text-align-center">
              {/* Scrollable container */}
              <div
                className="scrollable-container"
                style={{
                  overflow: 'auto', // Enables both vertical and horizontal scrolling
                  maxHeight: '400px', // Adjust to your modal's desired height
                  maxWidth: '100%', // Full-width container with scrolling as needed
                  padding: '10px',
                  border: '1px solid #ddd', // Optional: Visual border for clarity
                }}
              >
                <div className="panel setup-content">
                  <div className="panel-body view-form">
                    {/* Name of Student */}
                    <div className="form-group col-xs-12 col-sm-6 padding-xs-0">
                      <label className="control-label label-english">
                        Name of Student:
                      </label>
                      <span className="mandatory">*</span>
                      <label className="new-urdu">طالب علم کا نام</label>
                      <input
                        maxLength={200}
                        type="text"
                        placeholder="Name of Student"
                        className="form-control input-label-style"
                        id="name"
                        name="name"
                        value={props.applicationDetails?.name || ''}
                      />
                    </div>

                    {/* Father's Name */}
                    <div className="form-group col-xs-12 col-sm-6 padding-xs-0">
                      <label className="control-label label-english">
                        Father Name:
                      </label>
                      <span className="mandatory">*</span>
                      <label className="new-urdu">والد کا نام</label>
                      <input
                        maxLength={200}
                        type="text"
                        placeholder="Father's Name"
                        className="form-control input-label-style"
                        id="father_name"
                        name="father_name"
                        value={props.applicationDetails?.father_name || ''}
                      />
                    </div>

                    {/* Form-B/CNIC */}
                    <div className="form-group col-xs-12 col-sm-6 padding-xs-0">
                      <label className="control-label label-english">
                        Form-B/CNIC:
                      </label>
                      <span className="mandatory">*</span>
                      <label className="new-urdu">
                        فارم ب/ شناختی کارڈ نمبر
                      </label>
                      <input
                        maxLength={13}
                        type="text"
                        placeholder="6110112345678 (without dashes)"
                        className="form-control input-label-style"
                        id="cnic"
                        name="cnic"
                        value={props.applicationDetails?.cnic || ''}
                      />
                    </div>

                    {/* Father/Guardian CNIC */}
                    <div className="form-group col-xs-12 col-sm-6 padding-xs-0">
                      <label className="control-label label-english">
                        Father/Guardian CNIC:
                      </label>
                      <span className="mandatory">*</span>
                      <label className="new-urdu">
                        والد/سرپرست شناختی کارڈ نمبر
                      </label>
                      <input
                        maxLength={13}
                        type="text"
                        placeholder="6110112345678 (without dashes)"
                        className="form-control input-label-style"
                        id="father_cnic"
                        name="father_cnic"
                        value={props.applicationDetails?.father_cnic || ''}
                      />
                    </div>

                    {/* Form-B Picture */}
                    <div className="form-group col-xs-12 col-sm-6 padding-xs-0">
                      {props.applicationDetails?.form_b && (
                        <div>
                          <label className="control-label label-english">
                            Form-B Picture:
                          </label>
                          <span className="mandatory">*</span>
                          <label className="new-urdu">فارم ب کی تصویر</label>
                          <br />
                          <div className="col-xs-12 col-sm-12">
                            <img
                              src={props.applicationDetails.form_b}
                              className="img-rounded picture-size"
                              alt="Form-B Picture"
                              style={{ width: '200px', height: '200px' }}
                            />
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Student Picture */}
                    <div className="form-group col-xs-12 col-sm-6 padding-xs-0">
                      {props.applicationDetails?.photo && (
                        <div>
                          <label className="control-label label-english">
                            Student Picture:
                          </label>
                          <span className="mandatory">*</span>
                          <label className="new-urdu">طالب علم کی تصویر</label>
                          <br />
                          <div className="col-xs-12 col-sm-12">
                            <img
                              src={props.applicationDetails.photo}
                              className="img-thumbnail picture-size"
                              alt="Student Picture"
                              style={{ width: '200px', height: '200px' }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewForm;
